<header class="layout__header" *ngIf="user !== null">
  <div [@displayHeader]="headerState">
    <nav id="impersonate-header" class="navbar  navbar--header js-navbar-header impersonate-header" #navbarHeader>
      <div class="container-fluid nav justify-content-center py-1 px-4" *ngIf="isImpersonatedSubuser() || isImpersonatedIgo()">
        {{ 'impersonate_warning_part1' | translate }} {{ user?.profile?.userName }}. {{ 'impersonate_warning_part2' | translate }}
      </div>
    </nav>
    <nav class="navbar  navbar--header navbar-expand-lg  js-navbar-header app-header" #navbarHeader>
      <button class="navbar-toggler" type="button" aria-label="Toggle navigation" (click)="toogleMobileNav()">
        <span class="navbar-toggler__icon" [inlineSVG]="'assets/images/icons/icon-menu.svg'"></span>
        <span class="navbar-toggler__text">Menu</span>
      </button>

      <a class="navbar-brand" routerLink="/">
        <img *ngIf="domain?.logoUrl" class="navbar-brand__img-l  d-none d-md-block" [attr.src]="domain?.logoUrl" alt="Brand Logo" />
        <img *ngIf="domain?.faviconUrl" class="navbar-brand__img-s  d-md-none" [attr.src]="domain?.faviconUrl" alt="Brand Logo" />
      </a>

      <div class="credits-navbar impersonate-mobile" #creditsNavbar>
        <div class="d-flex">
          <span class="navbar-company  fs-12  d-lg-none  me-auto">{{ userLogin }}</span>
          <div class="credit-navbar">
            <ng-container *ngIf="user?.account?.postpaid || (credits && credits.money !== null)" [ngSwitch]="user?.account?.postpaid">
              <small class="credit-navbar__label" translate>topmenu_credits</small>
              <span class="credit-navbar__quantity-xl" *ngSwitchCase="false">
                {{ currency }} {{ creditFormattedDigits }}<small class="fs-13">{{ decimalSeparator }}{{ creditFormattedFractions }}</small>
              </span>
              <span class="credit-navbar__quantity-xl" *ngSwitchCase="true" translate>
                atlas_credits_postpaid_user_money
              </span>
            </ng-container>
          </div>
          <ng-container *ngIf="creditsList && !user?.account?.postpaid">
            <ng-container *ngFor="let credit of creditsList">
              <div *ngIf="credit.enabled" [@EnterLeave]="'doAnimate'" class="credit-navbar">
                <span class="credit-navbar__icon">
                  <img [ngClass]="{ 'credit-destination-flag': !!credit.credits.nation }" [src]="credit.icon" [alt]="credit.title" />
                </span>
                <span *ngIf="!credit.credits.nation && !credit.title" class="credit-navbar__label">{{
                  'credit_type_' + credit.credits.type + '_shortversion' | lowercase | translate
                }}</span>
                <span *ngIf="!credit.credits.nation && credit.title" class="credit-navbar__label">{{ credit.title }}</span>
                <span *ngIf="credit.credits.nation" class="credit-navbar__label nation-flag-{{ credit.credits.nation }}">{{
                  credit.credits.nation | uppercase
                }}</span>
                <strong class="credit-navbar__quantity">{{ formatIntNumber(credit.credits.quantity) }}</strong>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <ul class="navbar-nav">
        <li class="nav-item d-flex align-items-center credits-item">
          <a
            class="nav-link credits-icon"
            [ngClass]="{ expiring: false, expired: false }"
            href="#"
            id="navbar-dropdown-credits"
            role="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            (click)="dropdownOpend()"
            [attr.aria-expanded]="false"
          >
            <meta content="maximum-scale=1.5" />
            <div class="d-flex">
              <span class="nav-link__img-wrap">
                <span class="nav-link__img" [inlineSVG]="'assets/images/icons/icon-credits.svg'"> </span>
              </span>
              <!-- <span
                [ngClass]="{ 'info-icon-expiring': expiring && !opened, 'info-icon-expiring-visited': opened }"
                *ngIf="expiring && !expired"
                class="nav-link__img"
                [inlineSVG]="'assets/images/icons/icon-info-anyColor.svg'"
              >
              </span>
              <span
                [ngClass]="{ 'info-icon-expired': expired && !opened, 'info-icon-expired-visited': opened }"
                *ngIf="expired"
                class="nav-link__img"
                [inlineSVG]="'assets/images/icons/icon-info-anyColor.svg'"
              >
              </span> -->
            </div>
            <span class="nav-link__text" [attr.data-text]="'topmenu_credits_widget' | translate" translate>topmenu_credits_widget</span>
            <span class="nav-link__text  nav-link__text--short" [attr.data-text]="'topmenu_credits_short_title' | translate" translate
              >topmenu_credits_short_title</span
            >
          </a>
          <wsb-ui-dropdown-credits
            *ngIf="isCreditsPreferencesInitialized"
            aria-labelledby="navbar-dropdown-credits"
            [creditsList]="creditsList"
            [openSubs]="openSubs"
            [user]="user"
            [credit]="credits"
            [creditsUpdateInProgress]="creditsUpdateInProgress"
          ></wsb-ui-dropdown-credits>
        </li>
        <li *ngIf="allowProfileManageAndShopAndBilling" class="nav-item dropdown d-flex align-items-center">
          <span *ngIf="companyName" class="navbar__company  nav-link  d-none  d-lg-block">{{ companyName }}</span>
          <a
            class="nav-link"
            href="#"
            id="navbar-dropdown-profile"
            role="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="nav-link__img-wrap">
              <span class="nav-link__img" [inlineSVG]="'assets/images/icons/icon-admin-view.svg'"></span>
            </span>
            <span class="nav-link__text  nav-link__text--shorter" [attr.data-text]="'topmenu_account_settings' | translate" translate
              >topmenu_account_settings</span
            >
            <span class="nav-link__text  nav-link__text--short" [attr.data-text]="'topmenu_account_settings' | translate" translate
              >topmenu_account_settings</span
            >
          </a>
          <div class="dropdown-menu  dropdown-menu-end" aria-labelledby="navbar-dropdown-profile" id="profile-dropdown">
            <a *ngIf="companyName" class="dropdown-item  dropdown-item--accent  d-flex  flex-column" href="#">
              <span>{{ companyName }}</span>
            </a>
            <a class="dropdown-item" translate [routerLink]="['/account']" *ngIf="domain && domain.canViewSettings">topmenu_account</a>
            <a class="dropdown-item" *ngIf="menuEntries['internal_shop'] && hasBillingUrl" translate [routerLink]="['/billing']"
              >topmenu_billing</a
            >
            <!-- old <a class="dropdown-item" *ngIf="menuEntries['shop'] && hasBillingUrl" translate [routerLink]="['/billing']">topmenu_billing</a> -->
            <a class="dropdown-item" *ngIf="hasUserManagementUrl" translate [routerLink]="['/profile/manage']">topmenu_user_management</a>
          </div>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link"
            href="#"
            id="navbar-dropdown-profile2"
            role="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="nav-link__img-wrap">
              <span class="nav-link__img" [inlineSVG]="'assets/images/icons/icon-user.svg'"></span>
            </span>
            <span class="nav-link__text  nav-link__text--shorter" [attr.data-text]="'topmenu_user_settings' | translate" translate
              >topmenu_user_settings</span
            >
            <span class="nav-link__text  nav-link__text--short" [attr.data-text]="'topmenu_user_settings' | translate" translate
              >topmenu_user_settings</span
            >
          </a>
          <div class="dropdown-menu  dropdown-menu-end" aria-labelledby="navbar-dropdown-profile2" id="profile-dropdown2">
            <a class="dropdown-item  dropdown-item--accent  d-flex  flex-column" href="#">
              <span
                >{{ userFullName }} <small>{{ userLogin }}</small></span
              >
              <small>{{ userRegistrationEmail }}</small>
            </a>
            <a class="dropdown-item" translate [routerLink]="['/profile']">topmenu_user_settings</a>
            <a class="dropdown-item" *ngIf="isImpersonatedSubuser()" [routerLink]="['/deimpersonate']" translate>topmenu_disimpersonate</a>
            <a class="dropdown-item" *ngIf="!isImpersonatedSubuser()" [routerLink]="['/logout']" translate>topmenu_logout</a>
          </div>
        </li>
        <li class="nav-item dropdown" *ngIf="displayHelpButton()">
          <a
            class="nav-link"
            href="#"
            id="navbar-dropdown-help"
            role="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="nav-link__img-wrap">
              <span class="nav-link__img" [inlineSVG]="'assets/images/icons/icon-help.svg'"></span>
            </span>
            <span class="nav-link__text" [attr.data-text]="'topmenu_help' | translate" translate>topmenu_help</span>
            <span class="nav-link__text  nav-link__text--short" [attr.data-text]="'atlas_topmenu_help_title' | translate" translate
              >atlas_topmenu_help_title</span
            >
          </a>
          <div class="dropdown-menu  dropdown-menu-end" aria-labelledby="navbar-dropdown-help" id="help-dropdown">
            <a class="dropdown-item" routerLink="/support" translate>topmenu_support</a>
            <a class="dropdown-item" *ngIf="hasSupportGuideUrl" (click)="openGuide()" translate>topmenu_help_guide</a>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</header>
